// extracted by mini-css-extract-plugin
export var teamsSetupContainer = "TeamsSetup-module--teamsSetupContainer--32WaZ";
export var teamsSetupTitle = "TeamsSetup-module--teamsSetupTitle--2LU8U";
export var teamsContainer = "TeamsSetup-module--teamsContainer--L1dGq";
export var addTeamButton = "TeamsSetup-module--addTeamButton--1ZYiC";
export var teamsSetupSubmitButton = "TeamsSetup-module--teamsSetupSubmitButton--1i4j7";